export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request;
  return {
    // 公司押金 list
    getCompanyDepositList: function getCompanyDepositList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/company/deposit/order/list",
        method: "get",
        params: data
      });
    },
    // 公司押金新增
    saveCompanyDepositOrder: function saveCompanyDepositOrder() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/company/deposit/order/save",
        method: "post",
        data: data
      });
    },
    // 根据公司id获取押金list
    getCompanyDepositListByCompanyId: function getCompanyDepositListByCompanyId() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/company/deposit/order/listByCompanyId",
        method: "get",
        params: data
      });
    },
    // 审核待退还
    updateDepositRefunded: function updateDepositRefunded() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/company/deposit/order/updateRefunded",
        method: "post",
        data: data
      });
    },
    // 押金记录修改操作说明
    updateCompanyDepositOrder: function updateCompanyDepositOrder() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/company/deposit/order/update",
        method: "post",
        data: data
      });
    },
    // 获取待退还押金数
    getCompanyDepositRefundTotal: function getCompanyDepositRefundTotal() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/company/deposit/order/refundTotal",
        method: "get",
        params: data
      });
    },
    updateDepositRevocation: function updateDepositRevocation() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/company/deposit/order/revocation",
        method: "post",
        data: data
      });
    }
  };
});